export default __webpack_public_path__ + "static/media/landing2.64cc6cf2.jpg";